module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Montserrat:400,500,600,700"]}},
    },{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"CucuxuEfAsuwyFTO1cRbNbyOecBM6L5U","devKey":"CucuxuEfAsuwyFTO1cRbNbyOecBM6L5U","trackPage":false},
    }]
